<template>
  <div class="md-layout maxwidth">
    <div class=" md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      <div class="md-layout">
        <div class="md-layout-item" >

          <pricing-card icon-color="icon-success" class="fondo" >

            <div class="linkcontainer" slot="category">

              <span class="ml-2 instagram" v-if="stablishment.instagram" >
                <a :href="stablishment.instagram" target="_blank">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 16 16"><path fill="currentColor" d="M8 0C5.829 0 5.556.01 4.703.048C3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7C.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297c.04.852.174 1.433.372 1.942c.205.526.478.972.923 1.417c.444.445.89.719 1.416.923c.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417c.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046c.78.035 1.204.166 1.486.275c.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485c.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598c-.28.11-.704.24-1.485.276c-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598a2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485c-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486c.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276c.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92a.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217a4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334a2.667 2.667 0 0 1 0-5.334"/></svg>
                </a>
              </span>
              <span class="ml-2 website" v-if="stablishment.website">
                    <a :href="stablishment.website" target="_blank">
                    <svg height="30px" width="30px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 107.366 107.366" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path style="fill:#010002;" d="M107.366,53.683C107.366,24.082,83.283,0,53.683,0c-4.982,0-9.785,0.734-14.366,2.011L39.21,1.94 c-0.025,0.036-0.043,0.075-0.068,0.115C16.595,8.417,0,29.125,0,53.683c0,29.601,24.082,53.683,53.683,53.683 c4.985,0,9.785-0.734,14.366-2.011l0.107,0.075c0.025-0.036,0.047-0.075,0.068-0.115C90.77,98.948,107.366,78.237,107.366,53.683z M5.343,56.292H24.69c0.193,5.766,0.837,11.438,2.004,16.942H9.366C7.047,68.002,5.662,62.29,5.343,56.292z M102.022,51.077H82.679 c-0.197-5.769-0.837-11.442-2.008-16.946H98C100.319,39.364,101.704,45.076,102.022,51.077z M77.468,51.077h-21.18V34.131h19.061 C76.58,39.625,77.264,45.298,77.468,51.077z M56.292,28.924V5.343c2.53,0.136,5.014,0.415,7.43,0.923 c4.502,6.986,7.97,14.595,10.289,22.658H56.292z M51.077,28.924h-18.12c2.137-7.92,5.354-15.436,9.57-22.368 c2.766-0.655,5.622-1.056,8.55-1.213V28.924z M51.077,34.132v16.946H29.84c0.111-5.766,0.712-11.442,1.85-16.946H51.077z M24.633,51.077H5.34c0.319-6.002,1.704-11.717,4.023-16.946h17.046C25.335,39.654,24.741,45.319,24.633,51.077z M29.898,56.292 h21.18v16.942H32.013C30.785,67.74,30.102,62.068,29.898,56.292z M51.077,78.441v23.581c-2.53-0.136-5.018-0.415-7.43-0.923 c-4.502-6.986-7.97-14.595-10.293-22.658C33.355,78.441,51.077,78.441,51.077,78.441z M56.292,78.441h18.116 c-2.14,7.92-5.354,15.432-9.57,22.368c-2.766,0.659-5.622,1.056-8.55,1.213V78.441H56.292z M56.292,73.234V56.292h21.237 c-0.111,5.762-0.712,11.438-1.854,16.942C75.675,73.234,56.292,73.234,56.292,73.234z M82.732,56.292h19.294 c-0.319,6.002-1.704,11.714-4.023,16.942H80.957C82.031,67.712,82.625,62.047,82.732,56.292z M95.28,28.924H79.393 c-1.943-7.147-4.681-13.993-8.235-20.403C81.294,12.454,89.765,19.694,95.28,28.924z M35.219,8.883 c-3.31,6.32-5.848,13.041-7.627,20.038H12.086C17.425,19.991,25.514,12.898,35.219,8.883z M12.086,78.441h15.89 c1.94,7.147,4.678,13.993,8.231,20.403C26.072,94.911,17.601,87.671,12.086,78.441z M72.146,98.483 c3.31-6.32,5.848-13.041,7.627-20.038H95.28C89.94,87.374,81.852,94.467,72.146,98.483z"></path> </g> </g></svg>
                    </a>
              </span>
            </div>

     

           <div slot="category" v-if="stablishment !== undefined && stablishment.coverImage" class="w-100 mb-1">
             <img  :src="stablishment.coverImage" class="w-100 coverimage" />
              <div  class="logorestocontainer">  
              <div class="logoresto" :style="'background:url('+stablishment.logo+')'">
                 
              </div>  
              </div>  
          </div>

              <h4 :style="'color:'+stablishment.secondaryColor">{{stablishment.name}}</h4>
            <h6 v-if="menu.menuType != 'onsite'"  slot="category" class="category text-secondary" :style="colorStyle(stablishment.primaryColor)">
              {{order.buyerName}}, {{ $t('preparingOrder') }}
            </h6>
            <h5 slot="category" v-if="order.qr">{{order.qr.name}}</h5>
            <md-icon slot="icon">
              <img class="img cooking" :src="cooking" />
            </md-icon>
            <h3 class="mt-3" slot="title">{{ $t('orderNumber') }} #{{order.turnNumber}}</h3>

          <div slot="title" class="text-left md-layout-item md-size-100 md-medium-size-100 ">
            <md-card>
              <md-card-content>
           <StripePayment 
            v-if="order.clientSecret && !order.payed && menu.payment"
              :clientSecret="order.clientSecret"
              :amount="order.totalPrice*100"
              :currency="business.currency"
              country="US">
              </StripePayment>

                <collapse 
                  :collapse="[$t('myOrder')]"
                  icon="keyboard_arrow_up"
                  color-collapse="rose">
                  <template :slot="'md-collapse-pane-1'" v-if="order.products !== undefined && order.products.length > 0">
                    <md-table v-model="order.products" >
                      <md-table-row slot="md-table-row" slot-scope="{ item }" md-auto-select> 
                        <md-table-cell>
                          <div class="md-layout-item">
                            <div class="picture">
                              <img class="img" :src="item.img" />
                            </div>
                          </div>
                        </md-table-cell>
                        <md-table-cell class="tab-column align-left">
                          <strong>{{ getTranslatedName(item.product) }} x <span class="badge badge-primary">{{ item.quantity }}</span></strong> =
                          <span>{{ item.product.price }} {{currencySymbol}}  x {{ item.quantity }}</span>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </template>
                </collapse>
                <h5 
                  class="text-secondary mt-2">
                  <span 
                  :class="order.payed ? 'paid':''" >{{ $t('total') }}: {{order.totalPrice}} {{currencySymbol}} </span>
                  <small class="paidlabel text-success" v-if="order.payed">{{$t('yespaid')}}</small></h5>
                  <strong class=" text-success" v-if="menu.menuType == 'shipping'">Gracias por tu compra!</strong><br>
                  <small class="" v-if="menu.menuType == 'shipping'">{{$t('thankyoushipping')}}</small>
              </md-card-content>
            </md-card>
          </div>
            <div class="mt-4 w-100" slot="title" >
            <a  target="_blank" :href="url">  
             <md-button  class="md-white md-button px-3 py-2 custombutton">
              {{$t('viewMenu')}}
             </md-button>
            </a> 
            </div>

            <h6 v-if="menu.menuType == 'takeaway' && menu.requestAdditionalInfo" slot="title" class="title" :style="colorStyle(stablishment.primaryColor)">{{ $t('dontClose') }}</h6>
            <h6 v-if="menu.menuType == 'takeaway' && !menu.requestAdditionalInfo" slot="title" class="title" :style="colorStyle(stablishment.primaryColor)">{{ $t('popupNotification') }}</h6>
            <small v-if="menu.menuType == 'takeaway' && menu.requestAdditionalInfo" slot="title" class="text-secondary">{{$t('orderSummaryEmail')}}</small>


         



          </pricing-card>
          <MyWebSocket v-if="order._id" :userId="order._id" typeEvent="edit_order" @message="orderChanged($event)"></MyWebSocket>
         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from "@/pages/Orders/actions";
import { getMenuByOrderId } from "@/pages/Menu/actions";
import { Collapse, PricingCard } from "@/components";
import { StripePayment } from "@/pages";
import Swal from 'sweetalert2';

import {
  MyWebSocket
} from "@/components";


export default {
  components: {
    PricingCard,
    Collapse,
    StripePayment,
    MyWebSocket
  },

  computed: {
    currencySymbol() {
      const selectedCurrency = this.$currencies.find(option => option.value === this.business.currency);
      return selectedCurrency ? selectedCurrency.symbol : '';
    }
  },
  data() {
    return {
      subdomain: false,
      stablishment:false,
      menu: false,
      business:[],
      url:false,
      order: false,
      email: '',
      phone: '',
      cooking: '/img/bagshopping.gif',
      checkStatusInterval: null
    };
  },
  created() {
    this.getMenu();
    this.subdomain = window.location.hostname;

  },
  mounted() {
  },
  beforeDestroy() {
    this.stopCheckingOrderStatus();
  },
  methods: {
    orderChanged(status){
      this.showOrderReadyNotification(status)
    },
    parseParameter(param) {
      // Verificamos si el parámetro contiene el guion "-"
      if (!param.includes('-')) {
        return false; // Si no tiene "-", devolvemos false
      }

      // Dividimos el parámetro en dos partes usando el guion como separador
      const [id, host] = param.split('-');

      // Devolvemos un objeto con el ID y el host separados
      return { id, host };
    },
    getTranslatedName(item) {

      if(item.nameTranslations == undefined){
        return item.name
      }

      const translation = item.nameTranslations.find(t => t.language === this.selectedLanguage.toUpperCase());

      return translation && translation.value ? translation.value : item.name;
    },
    getTranslatedDescription(item) {
      if(item.descriptionTranslations == undefined){
        return item.description
      }
      const translation = item.descriptionTranslations.find(t => t.language === this.selectedLanguage.toUpperCase());

      return translation && translation.value ? translation.value : item.description;
    },
    buttonStyle(color) {
      return {
        backgroundColor: `${color} !important`,
      };
    },
    colorStyle(color) {
      return {
        color: `${color} !important`,
      };
    },
    requestLocationPermission() {
      if (navigator.permissions) {
        navigator.permissions.query({ name: 'geolocation' }).then(permission => {
          if (permission.state === 'granted') {
            this.getLocation();
          } else if (permission.state === 'prompt') {
            this.getLocation();
          } else {
            Swal.fire('Error', 'Permiso de geolocalización denegado.', 'error');
          }
        }).catch(() => {
          this.getLocation();
        });
      } else {
        this.getLocation();
      }
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.checkPosition, this.showError);
      } else {
        Swal.fire('Error', 'Geolocation is not supported by this browser.', 'error');
      }
    },
    checkPosition(position) {
      const userLat = position.coords.latitude;
      const userLng = position.coords.longitude;

      // Coordenadas del local
      const localLat = 40.712776; // Reemplaza con tu latitud
      const localLng = -74.005974; // Reemplaza con tu longitud
      const radius = 500; // Radio en metros

      const distance = this.calculateDistance(localLat, localLng, userLat, userLng);

      if (distance <= radius) {
        Swal.fire('¡Estás cerca!', `Estás a ${distance.toFixed(2)} metros del local.`, 'success');
      } else {
        Swal.fire('Estás lejos', `Estás a ${distance.toFixed(2)} metros del local.`, 'info');
      }
    },

    showError(error) {
      switch(error.code) {
        case error.PERMISSION_DENIED:
          Swal.fire('Error', 'User denied the request for Geolocation.', 'error');
          break;
        case error.POSITION_UNAVAILABLE:
          Swal.fire('Error', 'Location information is unavailable.', 'error');
          break;
        case error.TIMEOUT:
          Swal.fire('Error', 'The request to get user location timed out.', 'error');
          break;
        case error.UNKNOWN_ERROR:
          Swal.fire('Error', 'An unknown error occurred.', 'error');
          break;
      }
    },
    calculateDistance(lat1, lon1, lat2, lon2) {
      const R = 6371e3; // Radio de la Tierra en metros
      const φ1 = lat1 * Math.PI/180; // φ, λ en radianes
      const φ2 = lat2 * Math.PI/180;
      const Δφ = (lat2 - lat1) * Math.PI/180;
      const Δλ = (lon2 - lon1) * Math.PI/180;

      const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
                Math.cos(φ1) * Math.cos(φ2) *
                Math.sin(Δλ/2) * Math.sin(Δλ/2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

      const d = R * c; // en metros
      return d;
    },


    async getMenu() {
      try {
        const response = await getAction(this.$route.params.id);
        this.order = response.order;

        let info = this.parseParameter(this.$route.params.id);
        if(info){
          this.url = "https://"+info.host+".app.gotake.it/menu/"+this.order.qr._id;
        }else{
          this.url = "https://app.gotake.it/menu/"+this.order.qr._id;
        }
        this.business = response.order.stablishment.businessName;
        this.stablishment = response.order.stablishment;
         if(this.stablishment.primaryColor == '#FFFFFF' ||
        this.stablishment.primaryColor == '#ffffff' || 
        !this.stablishment.primaryColor){
          this.stablishment.primaryColor = '#333';
        }
        if(this.stablishment.secondaryColor == '#FFFFFF' ||
        this.stablishment.secondaryColor == '#ffffff' || 
        !this.stablishment.secondaryColor){
          this.stablishment.secondaryColor = '#333';
        }
        const response2 = await getMenuByOrderId(this.$route.params.id);

        this.menu = response2.result;

        document.body.style.backgroundColor = this.stablishment.primaryColor; // Agrega el background color
        if(this.menu.menuType == "takeaway"){
         // this.startCheckingOrderStatus();
        }

        if (this.order.status === 'done' || this.order.status === 'close') {
          this.showOrderReadyNotification(this.order.status);
          this.playReadySound();
        }
      } catch (error) {
        this.errorMessage = error.message;
      }
    },    
    playReadySound() {
      const audio = new Audio(require('@/assets/ready.mp3')); // Asegúrate de que la ruta es correcta
      audio.play().catch(error => {
        console.error('Error al reproducir el sonido:', error);
      });
    },
    startCheckingOrderStatus() {
      this.checkStatusInterval = setInterval(async () => {
        try {
          const response = await getAction(this.$route.params.id);
          if (this.order.status !== response.order.status) {
            this.order = response.order;
            if (this.order.status === 'done' || this.order.status === 'close') {
              this.showOrderReadyNotification(this.order.status);
              this.playReadySound();
            }
          }
        } catch (error) {
          console.error('Error verificando el estado de la orden:', error);
        }
      }, 2000); // Verifica el estado cada 2 segundos
    },
    stopCheckingOrderStatus() {
      if (this.checkStatusInterval) {
        clearInterval(this.checkStatusInterval);
      }
    },
    showOrderReadyNotification(status) {

      if(status === 'done'){
        if(this.menu.menuType == 'onsite'){
          Swal.fire({
            title: this.$t('orderReadyTitle'),
            text: this.$t('orderReadyText'),
            icon: 'success',
            confirmButtonText: 'OK'
          });
        }else if(this.menu.menuType == 'takeaway'){
              Swal.fire({
                title: this.$t('orderReadyTitle'),
                text: this.$t('orderReadyText'),
                icon: 'success',
                confirmButtonText: 'OK'
              });
        }else if(this.menu.menuType == 'shipping'){
              Swal.fire({
                title: this.$t('orderReadyTitle'),
                text: 'Tu pedido ha sido despachado a la dirección de envío. Te enviaremos un email con el seguimiento.',
                icon: 'success',
                confirmButtonText: 'OK'
              });
        }
      }
      if(status === 'close'){
        Swal.fire({
          title: this.$t('deliveryConfirmation'),
          text: this.$t('orderDelivered'),
          icon: 'success',
          confirmButtonText: 'OK'
        });
      }
    }
  }
};
</script>

<style lang="css" scoped>

.paid{
  text-decoration: line-through;
      text-decoration-color: black;
}

.paidlabel{
    font-family: 'Crisp Noto Sans Bold';
    font-style: italic;
    color: black;
    display: inline-block;
    transform: rotate(-28deg);
    margin-left: -28px;
}

.page-header,
.page-header:before {
      background-color: #fe85ae !important;
      background: #fe85ae !important;
}
.cooking{
      width: 80px !important;
}
.fondo{
  background:#fcfcff !important;
}
.custombutton{
  border-radius: 34px;
  border: 1px solid;
}
</style>
